/* Kardhini analytics — build brief section 17.
   Pushes GA4-shaped events to window.dataLayer. Everything is wrapped so a
   failure here can never block a purchase. */
(function () {
  'use strict';

  var ctx = window.kardhiniAnalytics;
  if (!ctx || !ctx.ready) return;
  var dl = (window.dataLayer = window.dataLayer || []);

  function push(name, ecommerce) {
    try {
      var payload = { event: name, source_page: ctx.path, page_type: ctx.pageType };
      if (ecommerce) {
        ecommerce.currency = ecommerce.currency || ctx.currency;
        payload.ecommerce = ecommerce;
      }
      // GA4 recommends clearing the previous ecommerce object first.
      dl.push({ ecommerce: null });
      dl.push(payload);
    } catch (e) {}
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (ctx.item) push('view_item', { items: [ctx.item] });

    if (ctx.items && ctx.items.length) {
      push('view_item_list', { item_list_name: ctx.listName, items: ctx.items });
    }

    if (ctx.pageType === 'search') {
      push('view_search_results', {
        search_term: ctx.searchTerm,
        results_count: ctx.searchResults,
        items: ctx.items || []
      });
    }

    // select_item — a click on any card in a list.
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.k-pcard');
      if (!card || !ctx.items || !ctx.items.length) return;
      var cards = Array.prototype.slice.call(document.querySelectorAll('.k-pcard'));
      var item = ctx.items[cards.indexOf(card)];
      if (item) push('select_item', { item_list_name: ctx.listName, items: [item] });
    });

    // add_to_cart — the real submit, so the sticky bar's proxy click counts once.
    var form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (form && ctx.item) {
      form.addEventListener('submit', function () {
        var qty = form.querySelector('[name="quantity"]');
        var item = Object.assign({}, ctx.item);
        item.quantity = qty ? parseInt(qty.value, 10) || 1 : 1;
        push('add_to_cart', { value: item.price * item.quantity, items: [item] });
      });
    }

    // view_size_guide — any link into the sizing guidance.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="sizing-and-care"], a[href*="how-to-wear"]');
      if (a) push('view_size_guide', null);
    });

    // click_whatsapp_fit_help — product name and path only, never a measurement.
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="wa.me"], a[href*="whatsapp"], [data-k-whatsapp]');
      if (!a) return;
      try {
        dl.push({
          event: 'click_whatsapp_fit_help',
          source_page: ctx.path,
          item_name: ctx.item ? ctx.item.item_name : undefined
        });
      } catch (err) {}
    });

    // select_waist_range — the variant picker, where a product has one.
    document.addEventListener('change', function (e) {
      var picker = e.target.closest && e.target.closest('variant-selects');
      if (!picker || !ctx.item) return;
      var value = e.target.value;
      try {
        dl.push({
          event: 'select_waist_range',
          source_page: ctx.path,
          item_id: ctx.item.item_id,
          item_name: ctx.item.item_name,
          waist_range: value
        });
      } catch (err) {}
    });

    // sign_up — the footer newsletter.
    var news = document.querySelector('.k-news-form');
    if (news) {
      news.addEventListener('submit', function () {
        try { dl.push({ event: 'sign_up', method: 'footer_newsletter', source_page: ctx.path }); } catch (err) {}
      });
    }
  });
})();
